import React from 'react';
import styled from 'styled-components';
import LandingPageHeader from '../../components/LandingPageHeader/LandingPageHeader';
import ErrorImg from '../../resources/images/error.png';
import { setPageAvailabilityData } from '../../DumbleData';

// Simple error page if a fair is invalid
const NotAvailable = () => {
	setPageAvailabilityData(true);

	return (
		<>
			<LandingPageHeader></LandingPageHeader>
			<StyledContainer>
				<StyledImage src={ErrorImg} alt=""></StyledImage>
				<StyledHeading>Unfortunately, the Book Fair Payment Portal is unavailable.</StyledHeading>
				<StyledText>
					Access to the Payment Portal is only possible starting 5 days before the Book Fair to 5 days after the fair ends. If you made no Payment Portal transactions during the Fair, if you
					didn&apos;t accept your Certificate of Agreement, or if your Fair was canceled, then you would also have no access to the Payment Portal.
				</StyledText>
			</StyledContainer>
		</>
	);
};

const StyledContainer = styled.div`
	margin-top: 122px;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 280px;
	margin-left: auto;
	margin-right: auto;
`;

const StyledImage = styled.img`
	margin-bottom: 24px;
`;

const StyledHeading = styled.h1`
	margin-top: 0;
	font-size: 28px;
	font-weight: 300;
	line-height: 32px;
	text-align: center;
	margin-bottom: 27px;
`;

const StyledText = styled.p`
	font-size: 13px;
	font-weight: 500;
	line-height: 15px;
	margin: 0;
`;

export default NotAvailable;
